import type { BrandTheme, PartialBrandTheme } from '../../types/BrandTheme'
import { brandTheme } from '../../types/BrandTheme'
import { merge } from 'theme-ui'
import { dirname } from 'path'
import {
  resolveFontFamily,
  resolveThemeUIFontSizes,
} from '@jotta/ui/FontConfig'

import './theme.css'

export const saturntheme: BrandTheme = merge.all<BrandTheme, PartialBrandTheme>(
  brandTheme,
  {
    branding: {
      brand: 'SATURN',
      themedir: dirname(new URL(import.meta.url).pathname),
      staticDir: 'saturn',
      height: 32,
    },
    fontSizes: resolveThemeUIFontSizes('saturn'),
    fonts: resolveFontFamily('saturn'),
    colors: {
      text: '#000',
      background: '#fff',
      primary: '#4A90E2',
      secondary: '#fff',
      accent: '#EF7C00',
      accentText: '#fff',
      focus: '#4A90E2',
      focusDark: '#4A90E2',
      border: '#eaeaea',
      gray: '#928d89',
      grayBg: '#45434c',
      onboarding: '#EF7C00',
    },
    buttons: {
      primary: {
        borderColor: 'accent',
        backgroundColor: 'accent',
        color: 'accentText',
        lineHeight: '34px',
        fontSize: '15px',
        border: '1px solid #DDDDDE',
        textDecoration: 'none',
        fontWeight: 'light',
        borderRadius: '2px',
        padding: '0 8px',
        minWidth: '128px',
        width: 'auto',
      },
      secondary: {
        variant: 'buttons.primary',
        color: '#58585B',
        background: '#fff',
        '&:not(:disabled):hover': {
          filter: 'brightness(0.9)',
          opacity: 0.9,
          borderColor: '#DDDDDE',
        },
      },
      error: {
        '&:not(:disabled):hover': {
          filter: 'brightness(0.9)',
          opacity: 0.9,
          borderColor: '#DDDDDE',
        },
      },
      download: {
        backgroundColor: 'background',
        minWidth: '156px',
        width: '100%',
        '&:not(:disabled):hover': {
          borderColor: 'rgba(0,0,0,.15)',
        },
      },
      openWebInterface: {
        p: '4px 8px',
        color: '#928d89',
        '&:not(:disabled):hover': {
          borderColor: 'rgba(0,0,0,.15)',
          color: '#232323',
        },
      },
      link: {
        color: 'text',
        '&:not(:disabled):hover': {
          textDecoration: 'underline',
          color: 'accent',
        },
      },
      copyInputButton: {
        backgroundColor: 'accent',
        borderColor: 'accent',
      },
      replyButton: {
        color: ' var(--color-text)',
      },
      replyButtonDarkMode: {
        color: 'background',
      },
    },
    forms: {
      toggle: {
        '&:checked::before': {
          backgroundColor: 'text',
        },
        '&:checked::after': {
          backgroundColor: 'text',
        },
      },
      checkbox: {
        fontSize: '11px',
        borderRadius: '3px',
        border: '1px solid',
      },
    },
    layout: {
      appHeader: {
        backgroundColor: 'secondary',
      },
      appHeaderHamburger: {
        color: '#45434C',
        '> svg': {
          color: '#45434C',
          opacity: 1,
          '&:hover': {
            color: '#333',
          },
        },
      },
      modalBackgroundPrimary: {
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
      },
    },
    cards: {
      compact: {
        color: 'rgba(69,67,76,.8)',
      },
      photoUploadSuccess: {
        '--action-button-text-opacity': 1,
        '--action-button-color': '#fff',
        bg: 'accent',
      },
      photoUpload: {
        '--action-button-text-opacity': 1,
      },
    },
    styles: {
      avatar: {
        borderRadius: '100%',
        fontSize: '13px',
        fontWeight: 'body',
        width: '36px',
        height: '36px',
        lineHeight: '36px',
      },
      downloadPageHeader: {
        color: 'black',
      },
      downloadSvg: {
        color: 'black',
      },
      fileIcon: {
        '--file-icon-border-color': '#656565',
        '--folder-icon-fill': '#f8f8f8',
      },
      timelineHeading: {
        fontSize: '20px',
        fontWeight: 500,
      },
      addMoreSvg: {
        color: 'accent',
        width: 4,
        height: 4,
      },
      newAlbumP: {
        fontWeight: 500,
        opacity: 0.8,
        color: 'grayBg',
      },
      defaultProfilePicSvg: {
        color: 'accent',
      },
    },
  },
)
export default saturntheme
